<template>
  <component :is="iconComponent" class="w-5 h-5" :title="displayName" />
</template>

<script setup lang="ts">
import { UsersIcon, LockClosedIcon, BuildingOfficeIcon } from '@heroicons/vue/24/outline'
import { DeckBaseAccess } from '~~/entities/deck'

interface Props {
  accessType: DeckBaseAccess
}

const props = defineProps<Props>()

const iconComponent = computed(() => {
  switch (props.accessType) {
    case DeckBaseAccess.Public:
      return UsersIcon
    case DeckBaseAccess.Private:
      return LockClosedIcon
    case DeckBaseAccess.CompanyView:
    case DeckBaseAccess.CompanyEdit:
      return BuildingOfficeIcon
    default:
      return UsersIcon
  }
})

const VIEW_ACCESS_TYPE_DISPLAY_MAP: Record<DeckBaseAccess, string> = {
  [DeckBaseAccess.Public]: 'Anyone with link',
  [DeckBaseAccess.Private]: 'Invite Only',
  [DeckBaseAccess.CompanyView]: 'Everyone in Company (View)',
  [DeckBaseAccess.CompanyEdit]: 'Everyone in Company (Edit)',
}

const displayName = computed(() => {
  return VIEW_ACCESS_TYPE_DISPLAY_MAP[props.accessType] || 'Unknown'
})
</script>
